<div class="flex flex-col gap-4">
  <div class="flex items-center justify-between">
    <h1 class="text-primary text-2xl font-bold" i18n="@@breadcrumbCancellationReasonedit">Edit Cancellation Reason</h1>
  </div>
</div>
<div class="mb-4 rounded-2xl p-[16px]">
  <app-cancellation-reasons-edit-component />
</div>
